import moment from 'moment'

export function structureDate(date: string, format: string): string {
  return moment(date).format(format)
}
